<template>
      <div class="">
          
       <!-- <pre>{{question_detail}}</pre>  -->
        <div
          v-for="(each_link, link_index) in question_detail.links"
          :key="link_index"
        >
         <!-- {{each_link}} -->
           <iframe v-if="each_link.url_type==1"
                  class="links-video"
                  
                  :src="`https://youtube.com/embed/${each_link.video_code}`"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  :allowfullscreen="true"
                ></iframe>

                <iframe v-if="each_link.url_type==2"
                  class="links-video"
                  :src="`https://player.vimeo.com/video/${each_link.video_code}`"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>

                <a :href="each_linkurl" v-if="each_link.url_type==3" />
        </div>


        </div>
</template>
<script>
export default {
  name: 'LinkPreviewComponent',
  props: ['question_detail'],
  components: {},
  mixins: [],
  mounted () {
    // if (this.type === 'Import') {
    // this.question_detail.links = (this.question_detail.links.length > 0) ? this.question_detail.links.map((url) => { return url.url }) : ['']
    // }
  },
  data () {
    return {
    }
  },
  watch: {},
  methods: {
    checkVideoLink (videoLink) {
      if (videoLink.includes('watch?v=')) {  
        return `${videoLink.split('watch?v=')[0]}embed/${videoLink.split('watch?v=')[1]}`
      } else if (videoLink.includes('https://youtu.be')) {
        return `https://youtube.com/embed${videoLink.split('https://youtu.be')[1]}`
      } else if (!videoLink.includes('player.vimeo.com')) {
        return `https://player.vimeo.com/video/${videoLink.split('vimeo.com/')[1]}`
      } else {
        return videoLink
      }
    }
  }
}
</script>
